import React, { useState } from "react";
import {
  Icon,
  Grid,
  Message,
  Segment,
  List,
  Statistic,
  Input,
  Label,
  Header,
  Button,
  Table,
  Image,
  Menu,
  Divider,
} from "semantic-ui-react";
import { injectIntl, FormattedMessage, Link } from "gatsby-plugin-intl";
import Layout from "../../components/Layout";
import EventBanner from "../../components/EventBanner";
import { Block } from "../../components/StyledComponent";
import imagePayment from "../../assets/payment.png";
import {
  PICPICK_DISCOUNT,
  PICPICK_YEARLY,
  getPrice,
  getUnitPrice,
  formatPrice,
  formatTablePrice,
} from "../../constants";

const BuyPage = ({ intl }) => {
  const [users, setUsers] = useState(5);
  const [yearly, setYearly] = useState(PICPICK_YEARLY);
  const [lifetime, setLifetime] = useState(false);
  const licenseType = lifetime ? "lifetime" : "subscription";

  const handleInputChange = (e, { value }) => {
    let inputValue = parseInt(value, 10);
    if (inputValue < 0 || inputValue > 999 || value === "") {
      inputValue = 0;
    }

    setUsers(inputValue);
  };

  const handleMinusClick = () => {
    if (users <= 1) {
      return;
    }

    setUsers(users - 1);
  };

  const handlePlusClick = () => {
    if (users >= 200) {
      return;
    }

    setUsers(users + 1);
  };

  if (intl.locale === "ko") {
    if (typeof window !== "undefined") {
      return window.location.replace("/");
    }
  }

  const buildCheckoutUrl = (license, quantity) => {
    return `/buy/checkout?license=${license}&quantity=${quantity}`;
  };

  const renderYearlyToggle = () => (
    <Button.Group compact>
      <Button
        onClick={() => setYearly(false)}
        color={!yearly ? "blue" : undefined}
      >
        <FormattedMessage id="buy_monthly" />
      </Button>
      <Button
        onClick={() => setYearly(true)}
        color={yearly ? "blue" : undefined}
      >
        <FormattedMessage id="buy_yearly" />
      </Button>
    </Button.Group>
  );

  const renderPriceLabel = () => {
    if (PICPICK_DISCOUNT) {
      return null;
    }
    if (lifetime || yearly) {
      return "USD";
    }
    return (
      <p className="label" style={{ margin: 8, textTransform: "none" }}>
        USD <br /> / <FormattedMessage id={yearly ? "buy_year" : "buy_month"} />
      </p>
    );
  };

  const renderSubscriptions = () => (
    <Block
      narrow
      color="gray"
      style={{ paddingTop: "2em", paddingBottom: 0, borderBottom: "none" }}
    >
      <Grid stackable columns={2}>
        <Grid.Row textAlign="center">
          <Grid.Column width={16}>
            <p style={{ margin: "2em" }}>
              <FormattedMessage id="buy_2_p1" />
            </p>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row stretched textAlign="center">
          <Grid.Column>
            <Segment padded>
              <Label attached="top">
                <FormattedMessage id="buy_for_individuals" />
              </Label>
              <Header as="h3" icon textAlign="center">
                <Icon name="user" />
                <Header.Content>
                  <FormattedMessage id="buy_single" />
                </Header.Content>
              </Header>
              <div>
                <Statistic
                  className={PICPICK_DISCOUNT ? "strike" : "no-strike"}
                  size={PICPICK_DISCOUNT ? undefined : "large"}
                  color="blue"
                  horizontal
                  label={renderPriceLabel()}
                  value={formatPrice(getPrice(1, "subscription", false))}
                />
                <br />
                {PICPICK_DISCOUNT && (
                  <>
                    <Statistic
                      style={{ marginTop: 0 }}
                      color="red"
                      value={formatPrice(getPrice(1, "subscription", true))}
                    />
                    <div style={{ marginBottom: "2em" }}>
                      <Label color="red">
                        {intl.formatMessage({ id: "text_limitedtimeoffer" })}
                      </Label>
                    </div>
                  </>
                )}
              </div>
              <div
                style={{ lineHeight: "38px", height: 38, marginBottom: "1em" }}
              >
                <FormattedMessage id="buy_single_p1" />
              </div>
              <Button
                size="big"
                color="orange"
                fluid
                content={intl.formatMessage({ id: "nav_buy" })}
                as={Link}
                to={buildCheckoutUrl("subscription", 1)}
              />
            </Segment>
          </Grid.Column>
          <Grid.Column>
            <Segment padded>
              <Label attached="top">
                <FormattedMessage id="buy_for_teams" />
              </Label>
              <Header as="h3" icon textAlign="center">
                <Icon name="users" />
                <Header.Content>
                  <FormattedMessage id="buy_team" />
                </Header.Content>
              </Header>
              <div>
                <Statistic
                  className={PICPICK_DISCOUNT ? "strike" : "no-strike"}
                  size={PICPICK_DISCOUNT ? undefined : "large"}
                  color="orange"
                  horizontal
                  label={renderPriceLabel()}
                  value={formatPrice(getPrice(users, "subscription", false))}
                />
                <br />
                {PICPICK_DISCOUNT && (
                  <>
                    <Statistic
                      style={{ marginTop: 0 }}
                      color="red"
                      value={formatPrice(getPrice(users, "subscription", true))}
                    />
                    <div style={{ marginBottom: "2em" }}>
                      <Label color="red">
                        {intl.formatMessage({ id: "text_limitedtimeoffer" })}
                      </Label>
                    </div>
                  </>
                )}
              </div>
              <div style={{ marginBottom: "1em" }}>
                <Input
                  name="users"
                  labelPosition="left"
                  type="text"
                  value={users}
                  action
                  onChange={handleInputChange}
                >
                  <Label basic style={{ fontWeight: "normal" }}>
                    <FormattedMessage id="buy_team_user" />
                  </Label>
                  <input style={{ width: 70, fontWeight: 700 }} />
                  <Button icon="minus" onClick={handleMinusClick} />
                  <Button icon="plus" onClick={handlePlusClick} />
                </Input>
              </div>
              <Button
                size="big"
                color="orange"
                fluid
                content={intl.formatMessage({ id: "nav_buy" })}
                as={Link}
                to={buildCheckoutUrl("subscription", users)}
              />
            </Segment>
          </Grid.Column>
        </Grid.Row>
        <Divider horizontal>
          {intl.formatMessage({ id: "checkout_or" })}
        </Divider>
      </Grid>
      <div style={{ textAlign: "center", paddingTop: 30, paddingBottom: 15 }}>
        <Link href="/license" name="/license" to="/license">
          {intl.formatMessage({ id: "buy_existing_user" })}
        </Link>
      </div>
    </Block>
  );

  const renderLifetime = () => (
    <Block
      color="gray"
      style={{ paddingTop: "2em", paddingBottom: 0, borderBottom: "none" }}
    >
      <Grid stackable columns={3}>
        <Grid.Row textAlign="center">
          <Grid.Column width={16}>
            <p style={{ margin: "2em" }}>
              <Icon name="sync alternate" />{" "}
              <FormattedMessage id="buy_pay_once" />
            </p>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row stretched textAlign="center">
          <Grid.Column>
            <Segment padded>
              <Label attached="top">
                <FormattedMessage id="buy_for_individuals" />
              </Label>
              <Header as="h3" icon textAlign="center">
                <Icon name="user" />
                <Header.Content>
                  <FormattedMessage id="buy_single_lifetime" />
                </Header.Content>
              </Header>
              <Statistic
                style={{ marginTop: 0 }}
                className={PICPICK_DISCOUNT ? "strike" : "no-strike"}
                size={PICPICK_DISCOUNT ? undefined : "large"}
                color="blue"
                horizontal
                label={renderPriceLabel()}
                value={formatPrice(getPrice(1, "lifetime", false))}
              />
              <br />
              {PICPICK_DISCOUNT && (
                <>
                  <Statistic
                    style={{ marginTop: 0 }}
                    color="red"
                    value={formatPrice(getPrice(1, "lifetime", true))}
                  />
                  <p>
                    <Label color="red">
                      {intl.formatMessage({ id: "text_limitedtimeoffer" })}
                    </Label>
                  </p>
                </>
              )}
              <div
                style={{ lineHeight: "38px", height: 38, marginBottom: "1em" }}
              >
                <FormattedMessage id="buy_single_p1" />
              </div>
              <Button
                size="big"
                color="orange"
                fluid
                content={intl.formatMessage({ id: "nav_buy" })}
                as={Link}
                to={buildCheckoutUrl("lifetime", 1)}
              />
            </Segment>
          </Grid.Column>
          <Grid.Column>
            <Segment padded>
              <Label attached="top">
                <FormattedMessage id="buy_for_teams" />
              </Label>
              <Header as="h3" icon textAlign="center">
                <Icon name="users" />
                <Header.Content>
                  <FormattedMessage id="buy_team_lifetime" />
                </Header.Content>
              </Header>
              <Statistic
                style={{ marginTop: 0 }}
                className={PICPICK_DISCOUNT ? "strike" : "no-strike"}
                size={PICPICK_DISCOUNT ? undefined : "large"}
                color="orange"
                horizontal
                label={renderPriceLabel()}
                value={formatPrice(getPrice(users, "lifetime", false))}
              />
              <br />
              {PICPICK_DISCOUNT && (
                <>
                  <Statistic
                    style={{ marginTop: 0 }}
                    color="red"
                    value={formatPrice(getPrice(users, "lifetime", true))}
                  />
                  <p>
                    <Label color="red">
                      {intl.formatMessage({ id: "text_limitedtimeoffer" })}
                    </Label>
                  </p>
                </>
              )}
              <div style={{ marginBottom: "1em" }}>
                <Input
                  name="users"
                  labelPosition="left"
                  type="text"
                  value={users}
                  action
                  onChange={handleInputChange}
                >
                  <Label basic style={{ fontWeight: "normal" }}>
                    <FormattedMessage id="buy_team_user" />
                  </Label>
                  <input style={{ width: 70, fontWeight: 700 }} />
                  <Button icon="minus" onClick={handleMinusClick} />
                  <Button icon="plus" onClick={handlePlusClick} />
                </Input>
              </div>
              <Button
                size="big"
                color="orange"
                fluid
                content={intl.formatMessage({ id: "nav_buy" })}
                as={Link}
                to={buildCheckoutUrl("lifetime", users)}
              />
            </Segment>
          </Grid.Column>
          <Grid.Column>
            <Segment padded>
              <Label attached="top">
                <FormattedMessage id="buy_for_enterprise" />
              </Label>
              <Header as="h3" icon textAlign="center">
                <Icon name="building" />
                <Header.Content>
                  <FormattedMessage id="buy_site_lifetime" />
                </Header.Content>
              </Header>
              <Statistic
                style={{ marginTop: 0 }}
                className={PICPICK_DISCOUNT ? "strike" : "no-strike"}
                size={PICPICK_DISCOUNT ? undefined : "large"}
                color="red"
                horizontal
                label={renderPriceLabel()}
                value={formatPrice(getPrice(1, "enterprise", false))}
              />
              <br />
              {PICPICK_DISCOUNT && (
                <>
                  <Statistic
                    style={{ marginTop: 0 }}
                    color="red"
                    value={formatPrice(getPrice(1, "enterprise", true))}
                  />
                  <p>
                    <Label color="red">
                      {intl.formatMessage({ id: "text_limitedtimeoffer" })}
                    </Label>
                  </p>
                </>
              )}
              <div
                style={{ lineHeight: "38px", height: 38, marginBottom: "1em" }}
              >
                <FormattedMessage id="buy_site_p1" />
              </div>
              <Button
                size="big"
                color="orange"
                fluid
                content={intl.formatMessage({ id: "nav_buy" })}
                as={Link}
                to={buildCheckoutUrl("enterprise", 1)}
              />
            </Segment>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Block>
  );

  return (
    <Layout ad={false} buy>
      <EventBanner showButton={false} />
      <Block
        large
        color="white"
        title={intl.formatMessage({ id: "section_plans" })}
        style={{ borderBottom: "none", paddingBottom: "1em" }}
      />
      <Menu
        attached="top"
        tabular
        style={{ justifyContent: "center" }}
        className="attached-tab-menu"
      >
        <Menu.Item
          name={intl.formatMessage({ id: "buy_subscriptions" })}
          active={!lifetime}
          onClick={() => setLifetime(false)}
        />
        <Menu.Item
          name={intl.formatMessage({ id: "buy_lifetime" })}
          active={lifetime}
          onClick={() => setLifetime(true)}
        />
      </Menu>
      {lifetime ? renderLifetime() : renderSubscriptions()}
      <Block
        narrow
        color="gray"
        style={{ paddingTop: "1em", paddingBottom: "3em" }}
      >
        <Grid>
          <Grid.Row centered>
            <Grid.Column width={16}>
              <Message icon size="small" positive style={{ marginTop: "1em" }}>
                <Icon name="lock" />
                <Message.Content>
                  <Message.Header style={{ marginBottom: 5 }}>
                    <FormattedMessage id="secure_order" />
                  </Message.Header>
                  <FormattedMessage id="text_bluesnap" />
                  <Image
                    src={imagePayment}
                    alt="payment"
                    style={{ marginTop: "1em" }}
                  />
                </Message.Content>
              </Message>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Block>
      <Block style={{ padding: "1em" }}>
        <Grid divided columns="equal" stackable>
          <Grid.Column style={{ padding: "2em" }}>
            <Header as="h3">
              <Icon name="lightning" />
              <Header.Content>
                <FormattedMessage id="buy_1_h1" />
                <Header.Subheader style={{ marginTop: 10 }}>
                  <FormattedMessage id="buy_1_p1" />
                </Header.Subheader>
              </Header.Content>
            </Header>
          </Grid.Column>
          <Grid.Column style={{ padding: "2em" }}>
            <Header as="h3">
              <Icon name="help circle" />
              <Header.Content>
                <FormattedMessage id="buy_3_h1" />
                <Header.Subheader style={{ marginTop: 10 }}>
                  <FormattedMessage
                    id="buy_3_p1"
                    values={{
                      contactus: (
                        <Link href="/contact" name="contact" to="/contact">
                          <FormattedMessage id="buy_3_p1_contactus" />
                        </Link>
                      ),
                    }}
                  />
                </Header.Subheader>
              </Header.Content>
            </Header>
          </Grid.Column>
        </Grid>
      </Block>
      <Block
        color="gray"
        title={intl.formatMessage({ id: "section_volumepricing" })}
      >
        <Grid divided stackable centered>
          {false && (
            <Grid.Row>
              <Grid.Column width={16} textAlign="center">
                {renderYearlyToggle()}
              </Grid.Column>
            </Grid.Row>
          )}
          <Grid.Row>
            <Grid.Column width={10}>
              <Table celled textAlign="center">
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell width={8}>
                      <FormattedMessage id="buy_table_h1" />
                    </Table.HeaderCell>
                    <Table.HeaderCell width={8}>
                      {`${intl.formatMessage({
                        id: "buy_table_h2",
                      })}`}
                      {!lifetime &&
                        ` / ${intl.formatMessage({
                          id: yearly ? "buy_year" : "buy_month",
                        })}`}
                    </Table.HeaderCell>
                  </Table.Row>
                </Table.Header>
                <Table.Body>
                  <Table.Row>
                    <Table.Cell>1</Table.Cell>
                    <Table.Cell>
                      <span
                        className={
                          PICPICK_DISCOUNT ? "price-strike" : "price-no-strike"
                        }
                      >
                        {formatTablePrice(
                          getUnitPrice(1, licenseType, false, yearly)
                        )}
                      </span>{" "}
                      {PICPICK_DISCOUNT && (
                        <>
                          <Icon disabled name="angle right" />
                          <span className="color-red">
                            {formatTablePrice(
                              getUnitPrice(1, licenseType, true, yearly)
                            )}
                          </span>
                        </>
                      )}
                    </Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell>2 &ndash; 4</Table.Cell>
                    <Table.Cell>
                      <span
                        className={
                          PICPICK_DISCOUNT ? "price-strike" : "price-no-strike"
                        }
                      >
                        {formatTablePrice(
                          getUnitPrice(2, licenseType, false, yearly)
                        )}
                      </span>{" "}
                      {PICPICK_DISCOUNT && (
                        <>
                          <Icon disabled name="angle right" />
                          <span className="color-red">
                            {formatTablePrice(
                              getUnitPrice(2, licenseType, true, yearly)
                            )}
                          </span>
                        </>
                      )}
                    </Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell>5 &ndash; 9</Table.Cell>
                    <Table.Cell>
                      <span
                        className={
                          PICPICK_DISCOUNT ? "price-strike" : "price-no-strike"
                        }
                      >
                        {formatTablePrice(
                          getUnitPrice(5, licenseType, false, yearly)
                        )}
                      </span>{" "}
                      {PICPICK_DISCOUNT && (
                        <>
                          <Icon disabled name="angle right" />
                          <span className="color-red">
                            {formatTablePrice(
                              getUnitPrice(5, licenseType, true, yearly)
                            )}
                          </span>
                        </>
                      )}
                    </Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell>10 &ndash; 24</Table.Cell>
                    <Table.Cell>
                      <span
                        className={
                          PICPICK_DISCOUNT ? "price-strike" : "price-no-strike"
                        }
                      >
                        {formatTablePrice(
                          getUnitPrice(10, licenseType, false, yearly)
                        )}
                      </span>{" "}
                      {PICPICK_DISCOUNT && (
                        <>
                          <Icon disabled name="angle right" />
                          <span className="color-red">
                            {formatTablePrice(
                              getUnitPrice(10, licenseType, true, yearly)
                            )}
                          </span>
                        </>
                      )}
                    </Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell>25 &ndash; 99</Table.Cell>
                    <Table.Cell>
                      <span
                        className={
                          PICPICK_DISCOUNT ? "price-strike" : "price-no-strike"
                        }
                      >
                        {formatTablePrice(
                          getUnitPrice(25, licenseType, false, yearly)
                        )}
                      </span>{" "}
                      {PICPICK_DISCOUNT && (
                        <>
                          <Icon disabled name="angle right" />
                          <span className="color-red">
                            {formatTablePrice(
                              getUnitPrice(25, licenseType, true, yearly)
                            )}
                          </span>
                        </>
                      )}
                    </Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell>100 &ndash;</Table.Cell>
                    <Table.Cell>
                      <span
                        className={
                          PICPICK_DISCOUNT ? "price-strike" : "price-no-strike"
                        }
                      >
                        {formatTablePrice(
                          getUnitPrice(100, licenseType, false, yearly)
                        )}
                      </span>{" "}
                      {PICPICK_DISCOUNT && (
                        <>
                          <Icon disabled name="angle right" />
                          <span className="color-red">
                            {formatTablePrice(
                              getUnitPrice(100, licenseType, true, yearly)
                            )}
                          </span>
                        </>
                      )}
                    </Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell>More</Table.Cell>
                    <Table.Cell>
                      <Link href="/contact" name="contact" to="/contact">
                        <FormattedMessage id="buy_table_p1" />
                      </Link>
                    </Table.Cell>
                  </Table.Row>
                </Table.Body>
              </Table>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Block>
      <Block>
        <List>
          <List.Item
            icon="right triangle"
            content={intl.formatMessage({ id: "text_license_peruser" })}
          />
          <List.Item
            icon="right triangle"
            content={intl.formatMessage({ id: "text_license_noshare" })}
          />
          <List.Item>
            <List.Icon name="right triangle" />
            <List.Content>
              <FormattedMessage
                id="buy_table_p2"
                values={{
                  vat: (
                    <span className="color-ng">
                      <FormattedMessage id="buy_table_p2_vat" />
                    </span>
                  ),
                }}
              />
            </List.Content>
          </List.Item>
        </List>
      </Block>
    </Layout>
  );
};

export default injectIntl(BuyPage);
